export function formatPageTitle(title: string, category?: string): string {
  const pageTitle = ["NADOHE", category, title].filter((node) => !!node).join(" | ");

  return pageTitle.length > 55 ? pageTitle.slice(0, 55) + "..." : pageTitle;
}
